// extracted by mini-css-extract-plugin
export var cancelButton = "_mj-5";
export var content = "_mj-3";
export var createButton = "_mj-6";
export var drawerContainer = "_mj-0";
export var footer = "_mj-2";
export var header = "_mj-1";
export var orderFormColumn = "_mj-4";